var _dec, _dec2, _dec3, _dec4, _class, _class2;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Brick } from "zengular";
import twig from "./magic-list.twig";
import "./magic-list.scss";
import magic from "../modules/magic";
import registry from "zengular/src/brick-registry";
import { MagicListButtonAddBrick, MagicListCardBasicBrick } from "zengular-magic";
var MagicListBrick = (_dec = Brick.register('magic-list', twig), _dec2 = Brick.listen(magic.event.search), _dec3 = Brick.listen(magic.event.addNewItem), _dec4 = Brick.listen(magic.event.selectItem), _dec(_class = (_class2 = /*#__PURE__*/function (_Brick) {
  _inherits(MagicListBrick, _Brick);

  var _super = _createSuper(MagicListBrick);

  function MagicListBrick() {
    _classCallCheck(this, MagicListBrick);

    return _super.apply(this, arguments);
  }

  _createClass(MagicListBrick, [{
    key: "buttons",
    get: function get() {
      return [MagicListButtonAddBrick];
    }
  }, {
    key: "limit",
    get: function get() {
      return 100;
    }
  }, {
    key: "search",
    get: function get() {
      return null;
    }
  }, {
    key: "card",
    get: function get() {
      return MagicListCardBasicBrick;
    }
  }, {
    key: "sorting",
    get: function get() {
      return {
        id: true
      };
    }
  }, {
    key: "onInitialize",
    value: function onInitialize() {
      this.pageCount = 0;
      this.handler = magic.getHandler(this.dataset.handler);
      this.searchParams = [];
      this.actor('list');
      this.currentpage = 1;
      this.sort = {};
      var sorting = this.sorting;

      for (var key in sorting) {
        if (sorting[key] === true || sorting[key] === null) {
          this.sort[key] = [_defineProperty({}, key, 'asc'), _defineProperty({}, key, 'desc')];
        } else if (sorting[key] === false) {
          this.sort[key] = [_defineProperty({}, key, 'desc'), _defineProperty({}, key, 'asc')];
        } else if (typeof sorting[key] === 'string') {
          this.sort[key] = [_defineProperty({}, sorting[key], 'asc'), _defineProperty({}, sorting[key], 'desc')];
        } else if (Array.isArray(sorting[key])) {
          this.sort[key] = sorting[key].slice(0, 2);
        } else if (_typeof(sorting[key]) === "object") {
          this.sort[key] = [sorting[key]];
        }
      }
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      return {
        sort: this.sort,
        handler: this.handler,
        search: this.search !== null ? this.search.tag : null
      };
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this = this;

      this.$$('quick-search').on.input(function () {
        return _this.loadList();
      }, 300);
      this.$$('open-search').on.click(function () {
        return _this.$$('search').node.classList.toggle('visible');
      });
      this.$$('page').on.input(function (event, target) {
        var page = parseInt(target.value);
        if (page < 1 || isNaN(page)) page = 1;
        target.value = page;

        _this.loadList(page);
      }, 300);
      this.$$('sort').on.input(function () {
        _this.loadList(1);
      });
      this.$$('prev').on.click(function (event) {
        var page = parseInt(_this.$$('page').node.value);
        page -= event.altKey ? 10 : 1;
        if (page < 1 || isNaN(page) || event.shiftKey) page = 1;
        _this.$$('page').node.value = page;

        _this.loadList(page);
      });
      this.$$('next').on.click(function () {
        var page = parseInt(_this.$$('page').node.value);
        page += event.altKey ? 10 : 1;
        if (page > _this.pageCount || isNaN(page) || event.shiftKey) page = _this.pageCount;
        _this.$$('page').node.value = page;

        _this.loadList(page);
      });
      this.buttons.forEach(function (button) {
        button.create('div', false).then(function (button) {
          button.list = _this;

          _this.$$('nav').node.appendChild(button.root);

          return button.render();
        });
      });
      this.loadList(1);
    }
  }, {
    key: "__search",
    value: function __search(event) {
      this.searchParams = event ? event.data.params : '';
      this.loadList(1);
    }
  }, {
    key: "__addNewItem",
    value: function __addNewItem(event) {
      event.data = this.handler.selectItemEventData();
    }
  }, {
    key: "__selectItem",
    value: function __selectItem(event) {
      event.data = this.handler.selectItemEventData(event.data.id);
    }
  }, {
    key: "loadData",
    value: function loadData(page) {
      var sortControl = this.$$('sort').node;
      var sort = this.sort[sortControl.children[sortControl.selectedIndex].value][sortControl.children[sortControl.selectedIndex].dataset.dir];
      var quickSearch = this.$$('quick-search').node.value;
      var search = this.searchParams.length ? this.searchParams : null;
      return this.handler.fetch.list(page, sort, quickSearch, search, this.limit).then(function (res) {
        return res.json();
      });
    }
  }, {
    key: "loadList",
    value: function loadList() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (page === null) page = this.currentpage;
      this.currentpage = page;
      var cardBrick = this.card;
      this.loadData(page).then(function (data) {
        _this2.$$('count').node.innerHTML = data.count;
        _this2.pageCount = Math.ceil(data.count / _this2.limit);
        _this2.$$('page-count').node.innerHTML = _this2.pageCount;
        _this2.$$('page').node.value = data.page;
        _this2.$$('list').node.innerHTML = '';
        data.items.forEach(function (item) {
          cardBrick.create('div', false).then(function (card) {
            card.dataset.handler = _this2.handler.name;
            card.list = _this2;
            card.render({
              id: item.id,
              item: item.data
            });

            _this2.$$('list').node.appendChild(card.root);
          });
        });
      });
    }
  }]);

  return MagicListBrick;
}(Brick), (_applyDecoratedDescriptor(_class2.prototype, "__search", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "__search"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "__addNewItem", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "__addNewItem"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "__selectItem", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "__selectItem"), _class2.prototype)), _class2)) || _class);
export { MagicListBrick as default };